import { render, staticRenderFns } from "./ChartReferralAge.vue?vue&type=template&id=0ec12ae8&"
import script from "./ChartReferralAge.vue?vue&type=script&lang=ts&"
export * from "./ChartReferralAge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports